import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { stringify } from 'query-string'

export const baseAPIPathGuruKS = process.env.NEXT_PUBLIC_API_PATH_PREFIX_GURU_KS
export const baseAPIPathGuruLMS =
  process.env.NEXT_PUBLIC_API_PATH_PREFIX_GURU_LMS
export const baseAPIPathGuruCore =
  process.env.NEXT_PUBLIC_API_PATH_PREFIX_GURU_CORE

export const baseUrl = process.env.NEXT_PUBLIC_API_URL
export const baseUrlAPIGuruKS = baseUrl + baseAPIPathGuruKS
export const baseUrlAPIGuruLMS = baseUrl + baseAPIPathGuruLMS
export const baseUrlAPIGuruCore = baseUrl + baseAPIPathGuruCore
export const baseUrlAPIPhicos = process.env.NEXT_PUBLIC_API_PHICOS_URL

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

const paramsSerializer = (params?: Record<string, unknown>): string =>
  stringify(params ?? {}, { arrayFormat: 'none' })

export const api = (opts?: AxiosRequestConfig): AxiosInstance => {
  return axios.create({
    baseURL: baseUrl,
    headers,
    paramsSerializer,
    ...opts,
  })
}
